class OaklenCollectionHero extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.index = 0;
    this.previousBodyOverflow = '';
    this.slides = Array.from(this.querySelectorAll('[data-oaklen-collection-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-oaklen-collection-thumb]'));
    this.currentCounter = this.querySelector('[data-oaklen-collection-current]');
    this.lightbox = this.querySelector('[data-oaklen-collection-lightbox]');
    this.lightboxImage = this.querySelector('[data-oaklen-collection-lightbox-image]');
    this.lightboxCurrent = this.querySelector('[data-oaklen-collection-lightbox-current]');
    this.prevButton = this.querySelector('[data-oaklen-collection-prev]');
    this.nextButton = this.querySelector('[data-oaklen-collection-next]');
    this.openLightboxButton = this.querySelector('[data-oaklen-collection-open-lightbox]');
    this.closeLightboxButton = this.querySelector('[data-oaklen-collection-close-lightbox]');
    this.lightboxPrevButton = this.querySelector('[data-oaklen-collection-lightbox-prev]');
    this.lightboxNextButton = this.querySelector('[data-oaklen-collection-lightbox-next]');
    this.handleKeydown = this.handleKeydown.bind(this);

    this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
    this.openLightboxButton?.addEventListener('click', () => this.openLightbox());
    this.closeLightboxButton?.addEventListener('click', () => this.closeLightbox());
    this.lightboxPrevButton?.addEventListener('click', () => this.goTo(this.index - 1, true));
    this.lightboxNextButton?.addEventListener('click', () => this.goTo(this.index + 1, true));
    this.lightbox?.addEventListener('click', (event) => {
      if (event.target === this.lightbox) {
        this.closeLightbox();
      }
    });

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.goTo(Number.parseInt(thumb.dataset.index || '0', 10));
      });
    });

    document.addEventListener('keydown', this.handleKeydown);
    this.goTo(0);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown(event) {
    if (this.lightbox && !this.lightbox.hidden) {
      if (event.key === 'Escape') {
        this.closeLightbox();
      }

      if (event.key === 'ArrowLeft') {
        this.goTo(this.index - 1, true);
      }

      if (event.key === 'ArrowRight') {
        this.goTo(this.index + 1, true);
      }
    }
  }

  goTo(nextIndex, syncLightbox = false) {
    if (this.slides.length === 0) return;

    this.index = (nextIndex + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });

    this.thumbs.forEach((thumb, index) => {
      const active = index === this.index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (this.currentCounter) {
      this.currentCounter.textContent = this.index + 1;
    }

    if (syncLightbox) {
      this.updateLightboxImage();
    }
  }

  openLightbox() {
    if (!this.lightbox || this.slides.length === 0 || !this.lightbox.hidden) return;

    this.updateLightboxImage();
    this.lightbox.hidden = false;
    this.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.closeLightboxButton?.focus();
  }

  closeLightbox() {
    if (!this.lightbox || this.lightbox.hidden) return;

    this.lightbox.hidden = true;
    document.body.style.overflow = this.previousBodyOverflow;
    this.previousBodyOverflow = '';
    this.openLightboxButton?.focus();
  }

  updateLightboxImage() {
    if (!this.lightboxImage || this.slides.length === 0) return;

    const activeSlide = this.slides[this.index];
    const activeImage = activeSlide?.querySelector('img');
    const fullImage = activeSlide?.dataset.fullImage || activeImage?.currentSrc || activeImage?.src || '';

    this.lightboxImage.replaceChildren();

    if (fullImage) {
      const image = new Image();
      image.src = fullImage;
      image.alt = activeImage?.alt || '';
      image.width = 1600;
      image.height = 1000;
      this.lightboxImage.appendChild(image);
    }

    if (this.lightboxCurrent) {
      this.lightboxCurrent.textContent = this.index + 1;
    }
  }
}

if (!customElements.get('oaklen-collection-hero')) {
  customElements.define('oaklen-collection-hero', OaklenCollectionHero);
}
